module.exports = __webpack_public_path__ + "static/fonts/fa-light-300.b21a41c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-light-300.eot
// module id = 1jxJ
// module chunks = 13 14